export default "__VITE_ASSET__DMV2a_ts__"